import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { fciWebsiteService } from '../../service/fci-website.service';
import { CustomServiceService } from '../../service/custom-service.service';
import {  EncryptDecryptService } from '../../service/encrypt-decrypt.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { FormControl, FormGroup, Validators } from '@angular/forms';
declare let $: any;
import * as CryptoJS from "crypto-js";
import { Buffer } from 'buffer';
import * as Aos from 'aos';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-content-search',
  templateUrl: './content-search.component.html',
  styleUrls: ['./content-search.component.css']
}) 
export class ContentSearchComponent implements OnInit {
  constructor(private fciwebservice: fciWebsiteService, private httpservice: CustomServiceService, private routerparam: ActivatedRoute, public encDec:EncryptDecryptService,private route: Router, public translate: TranslateService) { }
  
  language:any = sessionStorage.getItem('locale');//dynamic
  limit:number=50;
  currentPage:number = 1;
  totalRecords:number=0;

  backend_url: any = environment.serviceURL;
  site_url: any = environment.siteURL;
  btncontent:any = this.language=='English'?`Search`:'खोजें';
  ifdisabled:boolean=false;
  apirespons: any;
  globalsearchList: any[] = [];

  tenderlist:any[] = [];
  hastenderlist:boolean=false;

  recruitmentlist:any[] = [];
  hasrecruitmentlist:boolean=false;

  newslist:any[] = [];//3
  hasnewslist:boolean=false;

  pressReleaselist:any[] = [];//4
  haspressReleaselist:boolean=false;

  circularlist:any[] = [];//6
  hascircularlist:boolean=false;

  menulist:any[] = []; 
  hasmenulist:boolean=false;

  awardlist:any[] = [];
  hasawardlist:boolean=false;

  contentlist:any[] = [];
  hascontent:boolean=false;

  query_param:any = "";


CURRENT_ZONE_ID:any = environment.ZONE_ID;
CURRENT_REGION_ID:any = environment.REGION_ID;
CURRENT_ZONE_CODE:any = environment.ZONE_CODE;
CURRENT_REGION_CODE:any = environment.REGION_CODE;
datetime:any = this.httpservice.currentDateTime(); 
searchForm = new FormGroup({
  keywords: new FormControl(''),
});
menutimeInteval:any = null; 
  ngOnInit(): void {
    document.title="Content Search";
   
    if(window.localStorage.getItem('search_key')){

      this.query_param = window.localStorage.getItem('search_key');

    } else if(this.routerparam.snapshot.queryParamMap.get('query')) {
      
      this.query_param = this.routerparam.snapshot.queryParamMap.get('query');
    } else {
      this.query_param = "";
    }
    if(this.query_param!==""){
      this.RefreshBtn=true;
      this.globalsearch(this.query_param,this.currentPage,this.limit);
      this.searchForm.setValue({keywords:this.query_param}); 
    }
  
  }

 
  

  get keywords() {
    return this.searchForm.get('keywords');
  }
  
  RefreshBtn:boolean=false;
  RefreshPage(){
    this.RefreshBtn = false;
    this.searchForm.reset();
    $('#keywords').val('');
    this.globalsearchList=[];
    this.tenderlist=[];
    this.recruitmentlist=[];
    this.newslist=[];
    this.pressReleaselist=[];
    this.circularlist=[];
    this.menulist=[];
    this.awardlist=[];
    this.awardlist=[];
    this.contentlist = [];
    this.hastenderlist = false;
    this.haspressReleaselist = false;
    this.hasrecruitmentlist = false;
    this.hasnewslist = false;
    this.hascircularlist = false;
    this.hasmenulist = false;
    this.hasawardlist = false;
    this.hascontent=false;
    // this.route.navigateByUrl(`/contentsearch`);
    window.localStorage.removeItem('search_key');
    this.searchForm.patchValue({
      keywords: '',
    });
    this.limit = 50;
    this.currentPage=1;
    this.totalRecords = 0;
  }
 
  searchGlobal(){
    let param_arr = []; 
    let keywords;
    keywords="";
    if(this.searchForm.value.keywords!==""){
      if(this.searchForm.value.keywords!==null){
        param_arr.push(this.searchForm.value.keywords);
        keywords = this.searchForm.value.keywords;
      }
    }
    if(param_arr.length <= 0){
      if(this.language=='English'){
        alert('Please select at least one parameter');
      }else{
        alert('कृपया कम से कम एक पैरामीटर चुनें');  
      }
      return;
    }
    this.RefreshBtn=true;
    this.limit = 50;
    this.currentPage=1
    this.globalsearch(keywords,this.currentPage,this.limit);
    window.localStorage.removeItem('search_key');
  }




  globalsearch(keywords:any,currentPage:any,limit:any):any {
    this.ifdisabled = true;
    this.btncontent = `<i class="spinner-border spinner-size" aria-hidden="true"></i>`;
    this.globalsearchList=[];
    this.tenderlist=[];
    this.recruitmentlist=[];
    this.newslist=[];
    this.pressReleaselist=[];
    this.circularlist=[];
    this.menulist=[];
    this.awardlist=[];
    this.contentlist = [];
     
    this.hastenderlist = false;
    this.haspressReleaselist = false;
    this.hasrecruitmentlist = false;
    this.hasnewslist = false;
    this.hascircularlist = false;
    this.hasmenulist = false;
    this.hasawardlist = false;
    this.hascontent=false;
    if(keywords==""){
      this.ifdisabled = false;
      this.btncontent = this.language=='English'?`Search`:'खोजें';;
      return "";
    } 
    let params = {
      "limit": limit,
      "page": currentPage,
      "title": keywords,
      "zone_id": environment.ZONE_ID,
      "zone_code": environment.ZONE_CODE,
      "region_id": environment.REGION_ID,
      "region_code": environment.REGION_CODE,
    };//this.httpservice.mysql_real_escape_string()
    this.httpservice.GlobalSearchList(params).subscribe((response: HttpEvent<any>) => {
     
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
        this.apirespons = response.body;
        let respData = this.apirespons.RESPONSE_DATA;
        let respToken = this.apirespons.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
        if (respToken == verifyToken) {
          let response: any = Buffer.from(respData, 'base64');
          response = JSON.parse(response);
          // console.log(response.original);
          if(response.original.status){
            this.globalsearchList = response.original.paginationdata;
            this.totalRecords = response.original.pagination.total;
            
            // console.log(response.original.paginationdata);
            // console.log(typeof response.original.paginationdata);
            let list = response.original.paginationdata;
            for (let i = 0; i < list.length; i++) {
              if(list[i].table_type=='TENDER'){
                this.tenderlist.push(list[i]);
              } else if(list[i].table_type=='RECRUITMENT') {
                this.recruitmentlist.push(list[i]);
              } else if(list[i].table_type=='NEWS_TBL') {
                    if(list[i].section_type=='3'){//newslist
                      this.newslist.push(list[i]);
                    } else if(list[i].section_type=='4'){//pressReleaselist
                      this.pressReleaselist.push(list[i]);
                    } else if(list[i].section_type=='6'){//circularlist
                      this.circularlist.push(list[i]);
                    }   
              } else if(list[i].table_type=='MNG_AWARD') {
                this.awardlist.push(list[i]);
              } else if(list[i].table_type=='MENU_CONFIG') {
                this.menulist.push(list[i]);
              } else if(list[i].table_type=='CONTENTPAGE') {
                this.contentlist.push(list[i]);
              }
              
            }
            if(this.tenderlist.length > 0){
              this.hastenderlist = true;
            }
            if(this.recruitmentlist.length > 0){
              this.hasrecruitmentlist = true;
            }
            if(this.pressReleaselist.length > 0){
              this.haspressReleaselist = true;
            }
            if(this.newslist.length > 0){
              this.hasnewslist = true;
            }
            if(this.circularlist.length > 0){
              this.hascircularlist = true;
            }
            if(this.menulist.length > 0){
              this.hasmenulist = true;
            }
            if(this.awardlist.length > 0){
              this.hasawardlist = true;
            }
            if(this.contentlist.length > 0){
              this.hascontent = true;
            }
          }
          // console.log('tenderlist',this.tenderlist);
          // console.log('recruitmentlist',this.recruitmentlist);
          // console.log('pressReleaselist',this.pressReleaselist);
          // console.log('newslist',this.newslist);
          // console.log('circularlist',this.circularlist);
          // console.log('menulist',this.menulist);
          // console.log('awardlist',this.awardlist);
          // console.log('contentlist',this.contentlist);
        }
        this.ifdisabled = false;
        this.btncontent = this.language=='English'?`Search`:'खोजें';;
      }
    });
  }



  jsonConvert(data: any, type: any) {
    if(data=="" || data==null){
      return "";
    }
    if(data.jsonOptTxtDetails=="" || data.jsonOptTxtDetails == null){
      return "";
    }
    let d = JSON.parse(data.jsonOptTxtDetails);
    if (type == 'ZONE_ID') {
      return d.ZONE_ID;
    } else if (type == 'LINK_ID') {
      return d.LINK_ID;
    } else if (type == 'REGION_ID') {
      return d.REGION_ID;
    } else if (type == 'INTPARENTMENUID') {
      return d.INTPARENTMENUID;
    } else if (type == 'HAS_SUB_MENU') {
      return d.HAS_SUB_MENU;
    } else {
      return '';
    }
  }

htmlTag(data:any){
  return this.encDec.decodeHtml(data);
}

encode(data:any){
  return btoa(data);
}

  

encriptdata(id: any){
  return this.encDec.encText(id.toString());
}



viewDetails(id: any, pageName: any){
  let encSchemeStr = this.encDec.encText(id.toString());
  this.route.navigate(['/'+ pageName +'/', encSchemeStr]);
}




goToExtLink(url:any)
{
   Swal.fire({
    title: 'You are being redirected to an external website. Please note that Food Corporation of India (FCI) cannot be held responsible for external websites content & privacy policies.',
    text: 'Are you sure?',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No'
  }).then((result) => {
    if (result.value) {
      window.open(url, '_blank');
      //window.location.href = `${url} target="_blank"`;
      // var a = document.createElement('a');
      // a.target="_blank";
      // a.href=url;
      // a.text='External link';
      // a.id='external_url';
      // a.click();
      // document.getElementById('external_url')?.remove();
  }
});
}

returnrespons:any;
  getManu(menuid:any,_type:any) {
    let params = [{
      "secSlNo":1,
      "offSet":0, 
      "noOfRecords":0,
      "orderBy":[],
      "condition":[
        {"columnName":"tinPublishStatus","operator":"=","value":"1","joinoperator":"and"},
        {"columnName":"bitDeletedFlag","operator":"=","value":0,"joinoperator":"and"},
        {"columnName":"intId","operator":"=","value":menuid,"joinoperator":"and"},
      ],
      "viewParameters":""
   }];
    this.httpservice.getManuDetails(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.apirespons = response.body;
          let respData = this.apirespons.RESPONSE_DATA;
          let respToken = this.apirespons.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let response: any = Buffer.from(respData, 'base64');
            response = JSON.parse(response);
            if(response.result.sec_1.length > 0){
              this.returnrespons = response.result.sec_1[0];
              if(_type=='externale'){
                this.goToExtLink(this.returnrespons.externalLink);
              }
            } else {
              this.returnrespons = {};
            }
            // console.log(this.returnrespons);
          }
         
      }
    });
  }

  goToPluginPage(link:any,menudtl:any)
  {
   sessionStorage.removeItem(btoa(menudtl.selectPlugin));
   sessionStorage.setItem(btoa(menudtl.selectPlugin),JSON.stringify(menudtl));
   // this.route.navigate([link,""]);
   this.route.navigateByUrl('/', { skipLocationChange: true }).then(() =>
   this.route.navigate([link]));
  }
  
  goToContentPage(VCHMENUALIAS:any)
  {
      this.route.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.route.navigate(['./view'+'/'+VCHMENUALIAS]));
   } 
 



  setSelectedData(id:any)
  {
 let params = [{
   "secSlNo":1,
   "offSet":0, 
   "noOfRecords":0,
   "orderBy":[],
   "condition":[
     {"columnName":"tinPublishStatus","operator":"=","value":"1","joinoperator":"and"},
     {"columnName":"bitDeletedFlag","operator":"=","value":0,"joinoperator":"and"},
     {"columnName":"intId","operator":"=","value":id,"joinoperator":"and"}
   ],
   "viewParameters":""
 }];
 this.fciwebservice.getAll(params,"ManageMenu").subscribe((resp:any) => {
   let respData = resp.RESPONSE_DATA;
   let respToken = resp.RESPONSE_TOKEN;
 
   let verifyToken = CryptoJS.HmacSHA256(
     respData,
     environment.apiHashingKey 
   ).toString();
   if (respToken == verifyToken) {
     let response: any = Buffer.from(respData, 'base64');
     response = JSON.parse(response.toString());
   if(response.status==200)
     {
       if(response.result.sec_1.length > 0){ 
         this.route.navigateByUrl('/', { skipLocationChange: true }).then(() =>
         this.route.navigate(['./view'+'/'+response.result.sec_1[0].menuAlias])); 
       }
     }
   }
 });
   
  }






contentLengthSet(t:any,l:number):any{
  if(t==""){
    return "";
  } 
  let content = t;
  let totalcontent = content.split("");
  if(totalcontent.length <= l){
    return content;
  } else {
    return content.substring(0, l);
  }
}


pageChanged(page: any) {
  let param_arr = []; 
  let keywords;
  keywords="";
  if(this.searchForm.value.keywords!==""){
    if(this.searchForm.value.keywords!==null){
      param_arr.push(this.searchForm.value.keywords);
      keywords = this.searchForm.value.keywords;
    }
  }
 
  this.currentPage=page
  this.globalsearch(keywords,this.currentPage,this.limit);
}

 


}
